import { render, staticRenderFns } from "./toResetEmail.vue?vue&type=template&id=271dd290&scoped=true&"
import script from "./toResetEmail.vue?vue&type=script&lang=js&"
export * from "./toResetEmail.vue?vue&type=script&lang=js&"
import style0 from "./toResetEmail.vue?vue&type=style&index=0&id=271dd290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271dd290",
  null
  
)

export default component.exports